import React from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {Form, FormSelect} from "react-bootstrap"
import {Link} from "react-router-dom"
import {getCardDetailsFromDOM, getFieldDatesForAddUpdateCardBank} from "../functions"

export class ModalCreateCardBankClass extends React.Component {

    render() {

        const {lang, show, data, addCardHandler, cancelHandler, closeHandler, isNew} = this.props

        const changeNameHandler = (e) => {
            if (e.target.value !== '0') {
                e.target.classList.remove('is-invalid')
            } else {
                e.target.classList.add('is-invalid')
            }
        }

        const changeCurrencyHandler = (e) => {
            if (e.target.value !== '0') {
                e.target.classList.remove('is-invalid')
            } else {
                e.target.classList.add('is-invalid')
            }
        }

        const changeCardHandler = (e) => {
            const selectorDate = document.getElementById('selector-date')
            if (e.target.value !== 'Credit') {
                selectorDate.disabled = true
                document.querySelector('#div-selector-date').classList.add('d-none')
            } else {
                selectorDate.disabled = false
                document.querySelector('#div-selector-date').classList.remove('d-none')
            }
            if (e.target.value !== '0') {
                e.target.classList.remove('is-invalid')
            } else {
                e.target.classList.add('is-invalid')
            }
        }

        getFieldDatesForAddUpdateCardBank(lang, data)

        return (
            <>
                <Modal id={"create-modal"} show={show}>
                    <Modal.Header>
                        {!isNew && <Modal.Title className={'w-100 text-center'}>{data.title}</Modal.Title>}
                        {isNew && <Modal.Title className={'w-100 text-center'}>{lang.body.moneyPage.isNewUser.title}</Modal.Title>}
                        {!isNew && <Link to={`/${lang.lang}/money/settings`}>
                            <Button className={'ms-2'} variant={"close"} onClick={closeHandler}/>
                        </Link>}
                    </Modal.Header>
                    {!isNew && <Modal.Body id={'modal-body'}>
                        <Form className={'was-validated'}>
                            <div className={'ms-3 me-3'}>
                                <p className={'text-start'}>{lang.body.cardBankPage.descAdd}</p>
                            </div>
                            <fieldset className={'teal p-3'}>
                                <div id={"divNameCard"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.cardBankPage.labelName}
                                    </label>
                                    <input
                                        type={"text"}
                                        name={"nameCard"}
                                        id={"nameCard"}
                                        className={"form-control is-invalid"}
                                        onChange={changeNameHandler}
                                        required={true}
                                        placeholder={lang.body.cardBankPage.placeholderName}
                                    />
                                </div>
                                <div id={"divType"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.cardBankPage.labelType}
                                    </label>
                                    <FormSelect id={'select-type'}
                                                required={true}
                                                className={'is-invalid'}
                                                onChange={changeCardHandler}>
                                        <option value={''}>{lang.body.cardBankPage.labelType}</option>
                                        <option value={"Credit"}>{lang.body.cardBankPage.textTypeCreditCard}</option>
                                        <option value={"Debit"}>{lang.body.cardBankPage.textTypeDebitCard}</option>
                                    </FormSelect>
                                </div>
                                <div id={"divCurrency"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.cardBankPage.selectCurrencyLabel}
                                    </label>
                                    <FormSelect id={'select-currency'}
                                                required={true}
                                                className={'is-invalid'}
                                                onChange={changeCurrencyHandler}>
                                        <option value={''}>{lang.body.cardBankPage.currency}</option>
                                        <option value={"USD"}>{lang.body.cardBankPage.usd}</option>
                                        <option value={"ILS"}>{lang.body.cardBankPage.ils}</option>
                                        <option value={"EUR"}>{lang.body.cardBankPage.eur}</option>
                                        <option value={"RUB"}>{lang.body.cardBankPage.rub}</option>
                                    </FormSelect>
                                </div>
                                <div id={"divDefault"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.moneyPage.isNewUser.setDefault}
                                    </label>
                                    <input id={'input-default'}
                                           type={'checkbox'}
                                           required={false}
                                           className={'form-check-input is-invalid ms-3'}>
                                    </input>
                                </div>
                            </fieldset>
                        </Form>
                    </Modal.Body>}
                    {isNew && <Modal.Body id={'modal-body'}>
                        <Form className={'was-validated'}>
                            <div className={'ms-3 me-3'}>
                                <p className={'text-start'}>{lang.body.moneyPage.isNewUser.desc}</p>
                            </div>
                            <fieldset className={'teal p-3'}>
                                <div id={"divNameCard"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.moneyPage.isNewUser.currency}
                                    </label>
                                    <FormSelect id={'select-currency'}>
                                        <option value={'ILS'}>{'ILS'}</option>
                                        <option value={'USD'}>{'USD'}</option>
                                        <option value={'EUR'}>{'EUR'}</option>
                                        <option value={'RUB'}>{'RUB'}</option>
                                    </FormSelect>
                                </div>
                            </fieldset>
                        </Form>
                    </Modal.Body>}
                    <Modal.Footer>
                        {isNew && <Button
                            variant={data.btnOKColor}
                            onClick={() => {
                                const currency = document.querySelector('#select-currency').value
                                const res = {
                                    name: lang.body.moneyPage.cash,
                                    type: 'Cash',
                                    currency: currency,
                                    date: 'current-day',
                                    isDefault: true,
                                }
                                addCardHandler(res)
                            }}>
                            {lang.body.moneyPage.isNewUser.buttonSet}
                        </Button>}
                        {!isNew && <Button
                            variant={data.btnOKColor}
                            onClick={() => {
                                addCardHandler(getCardDetailsFromDOM())
                            }}>
                            {data.btnOK}
                        </Button>}
                        {!isNew && <Button
                            variant={data.btnCancelColor}
                            onClick={cancelHandler}>
                            {data.btnCancel}
                        </Button>}
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}